(function () {
  const VISUAL_GROUP_ATTRIBUTE = 'data-visual-group';
  const VISUAL_ATTRIBUTE_NAMES = new Set(['color', 'colour', 'pattern']);
  const isVisualAttributeName = (value) => normalizeVisualGroup(value)
    .split('-')
    .some((token) => VISUAL_ATTRIBUTE_NAMES.has(token));

  const normalizeVisualGroup = (value) => {
    if (!value) return '';
    return String(value)
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  const selectedVariant = (gallery, variantFromEvent) => {
    if (variantFromEvent) return variantFromEvent;
    const json = gallery?.closest('product-info')?.querySelector('[data-selected-variant]');
    if (!json) return null;
    try {
      return JSON.parse(json.textContent);
    } catch (error) {
      return null;
    }
  };

  const selectedVisualAttributeValue = (productInfo, position, eventData) => {
    const eventTarget = eventData?.target;
    const eventTargetName = eventTarget?.dataset?.optionName?.toLowerCase()?.trim();
    if (isVisualAttributeName(eventTargetName) && eventTarget.value) return eventTarget.value;

    const selectedOptions = productInfo?.querySelectorAll(
      'variant-selects fieldset input:checked, variant-selects select option[selected]'
    );
    const visualOption = [...(selectedOptions || [])].find((option) => {
      const name = option.dataset.optionName?.toLowerCase()?.trim();
      return isVisualAttributeName(name) && option.value;
    });
    if (visualOption) return visualOption.value;

    const variant = selectedVariant(productInfo?.querySelector('media-gallery'), null);
    return variant?.options?.[position] || '';
  };

  const mediaIdentity = (item) => item?.dataset?.mediaRawId || item?.dataset?.mediaId || '';
  const variantFeaturedMediaIdentity = (variant) => String(
    variant?.featured_media?.id || variant?.featured_media_id || ''
  );

  const updateCounter = (gallery, visibleItems) => {
    const counter = gallery.querySelector('.slider-counter');
    if (!counter) return;
    const activeIndex = visibleItems.findIndex((item) => item.classList.contains('is-active'));
    counter.querySelector('.slider-counter--current').textContent = String(Math.max(activeIndex + 1, 1));
    counter.querySelector('.slider-counter--total').textContent = String(visibleItems.length);
  };

  const filterVisualModal = (productInfo, visualGroup, fallbackIds) => {
    const modal = productInfo?.querySelector('product-modal');
    if (!modal) return;
    const items = [...modal.querySelectorAll(`[${VISUAL_GROUP_ATTRIBUTE}][data-media-id]`)].filter(
      (item) => item.closest('.product-media-modal__content')
    );
    if (!items.length) return;

    const matching = items.filter((item) => item.dataset.visualGroup === visualGroup || item.dataset.visualGroup === 'global');
    const fallback = items.filter((item) => fallbackIds.has(mediaIdentity(item)));
    const allowed = [...new Set([...matching, ...fallback])];
    const visible = allowed.length ? allowed : items;
    items.forEach((item) => {
      item.hidden = !visible.includes(item);
    });

    const active = modal.querySelector('.product-media-modal__content [data-media-id].active');
    if (active?.hidden) {
      active.classList.remove('active');
      visible[0]?.classList.add('active');
    }
  };

  const filterVisualGallery = (gallery, variantFromEvent, visualValue) => {
    const position = Number.parseInt(gallery.dataset.visualOptionPosition, 10);
    if (!Number.isInteger(position) || position < 0) return;

    const variant = selectedVariant(gallery, variantFromEvent);
    const visualGroup = normalizeVisualGroup(visualValue || variant?.options?.[position]);
    if (!visualGroup) return;

    const items = [...gallery.querySelectorAll('.product__media-list > li[data-media-id]')];
    if (!items.length) return;
    const hasVisualSpecificMedia = items.some(
      (item) => item.dataset.visualGroup && item.dataset.visualGroup !== 'global'
    );
    if (!hasVisualSpecificMedia) return;

    const matching = items.filter((item) => item.dataset.visualGroup === visualGroup || item.dataset.visualGroup === 'global');
    const selectedFeaturedId = variantFeaturedMediaIdentity(variant);
    const selectedFeatured = selectedFeaturedId
      ? items.find((item) => mediaIdentity(item) === selectedFeaturedId)
      : null;
    const visibleItems = [...new Set([...matching, selectedFeatured].filter(Boolean))];
    const finalItems = visibleItems.length ? visibleItems : items;
    const visibleIds = new Set(finalItems.map(mediaIdentity));
    items.forEach((item) => {
      item.hidden = !visibleIds.has(mediaIdentity(item));
    });

    const thumbnails = [...gallery.querySelectorAll('.thumbnail-list > li[data-target]')];
    thumbnails.forEach((thumbnail) => {
      const matchingItem = items.find((item) => mediaIdentity(item) === (thumbnail.dataset.mediaRawId || thumbnail.dataset.target));
      thumbnail.hidden = !matchingItem || matchingItem.hidden;
    });

    let active = items.find((item) => item.classList.contains('is-active') && !item.hidden);
    if (!active) {
      active = finalItems[0];
      items.forEach((item) => item.classList.remove('is-active'));
      active?.classList.add('is-active');
      if (active) gallery.setActiveMedia?.(active.dataset.mediaId, false);
    }

    gallery.querySelector('slider-component')?.resetPages?.();
    updateCounter(gallery, finalItems);
    filterVisualModal(gallery.closest('product-info'), visualGroup, visibleIds);
  };

  const init = () => {
    document.querySelectorAll('media-gallery[data-visual-option-position]').forEach((gallery) => {
      filterVisualGallery(gallery);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
        const source = data?.event?.target || data?.target;
        const productInfo = source?.closest?.('product-info');
        if (!productInfo) return;

        productInfo.querySelectorAll('media-gallery[data-visual-option-position]').forEach((gallery) => {
          const position = Number.parseInt(gallery.dataset.visualOptionPosition, 10);
          if (Number.isInteger(position) && position >= 0) {
            filterVisualGallery(gallery, null, selectedVisualAttributeValue(productInfo, position, data));
          }
        });
      });

      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        document.querySelectorAll('media-gallery[data-visual-option-position]').forEach((gallery) => {
          if (!data?.sectionId || gallery.id === `MediaGallery-${data.sectionId}`) {
            filterVisualGallery(gallery, data?.variant);
          }
        });
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
